import React from 'react';

const EmptyExploreImage: React.FC = () => {
  return <img height="100vh" src="/images/emptyExplore.svg" alt="ConnectX Logo" />;
};

export default EmptyExploreImage;
